import Vue from 'vue';

export const store = Vue.observable({
  isNavOpen: false,
  currentHatch: 'All Hatches' || 'Smart Hatch',
});

export const mutations = {
  setIsNavOpen(yesno) {
    store.isNavOpen = yesno;
  },
  toggleNav() {
    store.isNavOpen = !store.isNavOpen;
  },
  setCurrentHatch(title) {
    store.currentHatch = title;
  },
};
